import type { FC } from 'react';
import type { ButtonProps } from 'react-native-paper';
import { Button } from 'react-native-paper';

import { ArrowOutwardIcon } from '@/assets';
import { handleOpenUrl } from '@/shared/utils/url';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

// todo: unify all "Mehr erfahren" buttons -> LearnMoreButton. It seems we only have outlined and contained as difference

export const UrlButton: FC<ButtonProps & { url: string }> = ({
  url,
  children,
  ...props
}) => {
  const theme = useAppTheme();

  const handlePress = () => handleOpenUrl(url);

  return (
    <Button
      mode="contained"
      buttonColor={theme.colors.primary}
      onPress={handlePress}
      icon={({ color, size }) => (
        <ArrowOutwardIcon fill={color} width={size} height={size} />
      )}
      {...props}
    >
      {children}
    </Button>
  );
};
